import { Controller } from '@nestjs/common';

@Controller('id-proofs')
export class IdProofsController {}
